<template>
  <router-link
    v-if="routerName && query"
    :to="{ name: routerName, query: query }"
    class="btn-back"
    :class="[variant, size]"
    @click="clickHandler"
    @input="sendInputEvent(trackingName)"
    @focus="sendFocusEvent(trackingName)"
    @blur="sendBlurEvent(trackingName)"
    @mousedown="sendMousedownEvent(trackingName)"
    @mouseover="sendMouseoverEvent(trackingName)"
    @mouseout="sendMouseoutEvent(trackingName)"
    @keydown="sendKeydownEvent(trackingName)"
    @keyup="sendKeyupEvent(trackingName)"
  >
    <slot></slot>
  </router-link>
  <router-link
    v-else-if="routerName"
    :to="{ name: routerName }"
    class="btn-back"
    :class="[variant, size]"
    @click="clickHandler"
    @input="sendInputEvent(trackingName)"
    @focus="sendFocusEvent(trackingName)"
    @blur="sendBlurEvent(trackingName)"
    @mousedown="sendMousedownEvent(trackingName)"
    @mouseover="sendMouseoverEvent(trackingName)"
    @mouseout="sendMouseoutEvent(trackingName)"
    @keydown="sendKeydownEvent(trackingName)"
    @keyup="sendKeyupEvent(trackingName)"
  >
    <slot></slot>
  </router-link>
  <a
    v-else-if="href"
    :href="href"
    class="btn-back"
    :class="[variant, size]"
    @click="clickHandler"
    @input="sendInputEvent(trackingName)"
    @focus="sendFocusEvent(trackingName)"
    @blur="sendBlurEvent(trackingName)"
    @mousedown="sendMousedownEvent(trackingName)"
    @mouseover="sendMouseoverEvent(trackingName)"
    @mouseout="sendMouseoutEvent(trackingName)"
    @keydown="sendKeydownEvent(trackingName)"
    @keyup="sendKeyupEvent(trackingName)"
  >
    <slot></slot>
  </a>
  <button
    v-else
    class="text btn-back"
    :class="[variant, size]"
    @click="clickHandler"
  >
    <slot></slot>
  </button>
</template>

<script>
import {
  sendInputEvent,
  sendFocusEvent,
  sendBlurEvent,
  sendClickEvent,
  sendMousedownEvent,
  sendMouseoverEvent,
  sendMouseoutEvent,
  sendKeydownEvent,
  sendKeyupEvent,
} from "@/utils/FormEvent";
export default {
  name: "BtnBack",
  props: {
    variant: { type: String, default: "" },
    size: { type: String, default: "" },
    routerName: { type: String, default: "" },
    href: { type: String, default: "" },
    query: { type: Object, default: () => {} },
    trackingName: { type: String, default: "" },
  },
  emits: ["click"],
  setup() {
    return {
      sendInputEvent,
      sendFocusEvent,
      sendBlurEvent,
      sendClickEvent,
      sendMousedownEvent,
      sendMouseoverEvent,
      sendMouseoutEvent,
      sendKeydownEvent,
      sendKeyupEvent,
    };
  },
  methods: {
    clickHandler: function (e) {
      this.sendClickEvent(this.trackingName);
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-back {
  display: inline-block;
  width: 380px;
  max-width: 100%;
  text-align: center;
  padding: 17px 0px;
  border-radius: 27px;
  font-size: 14px;
  line-height: 14px;
  background-position: 18px center;
  background-repeat: no-repeat;
  background-size: 8px auto;
  @include mq-up(md) {
    border-radius: 30px;
    font-size: 20px;
    line-height: 24px;
  }
  &.-back {
    background-image: url("@/assets/images/icons/arrow-left-orange.svg");
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
    &:hover {
      background-image: url("@/assets/images/icons/arrow-left-orange.svg");
      border: 1px solid $primary;
    }
  }
  &.-md {
    background-image: url("@/assets/images/icons/arrow-left-orange.svg");
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
    &:hover {
      background-image: url("@/assets/images/icons/arrow-left-orange.svg");
    }
  }
  &.-sm {
    width: 240px;
    font-size: 14px;
    padding: 13px 0px;
    @include mq-up(md) {
      width: 160px;
      font-size: 16px;
      line-height: 16px;
    }
  }
}
</style>
